import React from "react";
import { faAdjust, faArrowsAlt, faRobot, faTimesCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Button from "@/components/button";
import { ButtonBar, Module } from "@/components/layouts/";
import { ButtonGroup } from "@/components/layouts/button-group";
import { useModal } from "@/hooks/use-modal";

import AnibotFadeModal from "./anibot/anibot-fade";
import AnibotMoveModal from "./anibot/anibot-move";
import ModalTitle from "./modal-title";

const AnibotModal = () => {
  const { openModal, closeModal } = useModal();

  return (
    <div className="text-center">
      <ModalTitle>
        <FontAwesomeIcon icon={faRobot} /> Tweenbot
      </ModalTitle>
      <Module>
        <p>
          Tweenbot can apply effects automatically. Please choose an effect:
        </p>
      </Module>
      <ButtonBar>
        <ButtonGroup align="centre">
          <Button
            icon={faArrowsAlt}
            onClick={() => openModal(() => <AnibotMoveModal />)}
            type="neutral"
          >
            Move Layer
          </Button>
          <Button
            icon={faAdjust}
            onClick={() => openModal(() => <AnibotFadeModal />)}
            type="neutral"
          >
            Fade Layer
          </Button>
        </ButtonGroup>
      </ButtonBar>

      <ButtonBar>
        <ButtonGroup align="right">
          <Button
            icon={faTimesCircle}
            onClick={closeModal}
            type="negative"
            rightAlign
          >
            Cancel
          </Button>
        </ButtonGroup>
      </ButtonBar>
    </div>
  );
};

export default AnibotModal;
